import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';

export const LandingPage = styled.div`
  min-height: 1100px; /* HACK: IE11 cant calculate height of this page, fix this when */
`;

export const Content = styled.div`
  margin-top: 30px;
  padding-left: ${layout.spacing.xSmall};
  padding-right: ${layout.spacing.xSmall};

  ${media.mediumDown`
    margin-top: 20px;
    margin-bottom: 20px;
  `};
`;
